var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("travelService.contactConsultants")) + ":")
      ]),
      _vm._l(_vm.contactPersons, function(contact, index) {
        return _c(
          "v-sheet",
          {
            key: index,
            staticClass: "ma-4 px-4",
            attrs: { color: "gray", "max-width": "400px", elevation: "5" }
          },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "pa-3", attrs: { cols: "4" } },
                  [
                    _c("v-icon", { staticStyle: { "font-size": "90px" } }, [
                      _vm._v("fa-user-circle")
                    ])
                  ],
                  1
                ),
                _c("v-col", { staticClass: "pa-4", attrs: { cols: "8" } }, [
                  _c("h2", { staticClass: "mt-6" }, [
                    _vm._v(_vm._s(contact.fullName))
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }